import type { FC } from 'react';
import { Button } from '@components/ui/button';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@components/ui/empty';
import { FolderOpenIcon } from '@heroicons/react/outline';
import pluralize from 'pluralize';

interface TableEmptyFilterStateProps {
  entityName: string;
  onClearFilters?: () => void;
}

export const TableEmptyFilterState: FC<TableEmptyFilterStateProps> = ({ entityName, onClearFilters }) => {
  return (
    <Empty className="absolute inset-0">
      <EmptyHeader className="max-w-2xl">
        <EmptyMedia className="size-12 bg-transparent text-gray-400" variant="icon">
          <FolderOpenIcon className="size-12 text-gray-400" />
        </EmptyMedia>
        <EmptyTitle className="text-xl font-bold text-gray-700">No {pluralize(entityName)} match</EmptyTitle>
        <EmptyDescription className="text-base font-normal text-gray-500">
          No {entityName} found, try adjusting or clearing your filters
        </EmptyDescription>
      </EmptyHeader>
      {onClearFilters && (
        <EmptyContent>
          <Button onClick={onClearFilters}>Clear all filters</Button>
        </EmptyContent>
      )}
    </Empty>
  );
};
